import React from "react";
import { Box, Text } from "@salestrak/ui";

export const QUICK_EMOJIS = [
  // Smileys
  "😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😂",
  "🙂", "😊", "😇", "🥰", "😍", "🤩", "😘", "😋",
  "🤔", "🤗", "😎", "🥳", "😤", "😢", "😭", "😱",
  // Gestures
  "👍", "👎", "👏", "🙌", "🤝", "🙏", "💪", "✌️",
  // Hearts & symbols
  "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "💯",
  // Objects & nature
  "🔥", "⭐", "✨", "🎉", "🎊", "💡", "🚀", "👀",
  // Misc
  "✅", "❌", "⚠️", "💬", "📌", "🏆", "💎", "🫡",
];

interface EmojiPickerProps {
  onSelect: (emoji: string) => void;
}

export function EmojiPicker({ onSelect }: EmojiPickerProps) {
  return (
    <Box direction="row" gap="none" wrap>
      {QUICK_EMOJIS.map((emoji) => (
        <Box
          as="button"
          key={emoji}
          onClick={() => onSelect(emoji)}
          align="center"
          justify="center"
          rounded="sm"
          hoverBackground
          width={32}
          height={32}
        >
          <Text size="base">{emoji}</Text>
        </Box>
      ))}
    </Box>
  );
}
